// ESM-Huelle fuer lib/scripts/components/CMP_CFocusElement.js (ESM-Welle 5b).
// Originalquelltext unveraendert uebernommen; nur Import/Export sind neu.
// Prototype-Stil bleibt - class-Migration ist ein separater Schritt.
import { CComponent } from './component.js';

function CFocusElement (id)
{
    this.construct (id);

    this.name = "CFocusedElement";
    this.htmlType = "input";
    
    this.properties =
    {
        styles:
        {
            position: "absolute"
        },
        events:
        {
            onKeyup: true,
            onBlur: true,
            onFocus: true
        }
    }
}

CFocusElement.prototype = new CComponent;

CFocusElement.prototype.gotKey = function (value) {}
export { CFocusElement };
